document.addEventListener('DOMContentLoaded', () => {
  const PERSONALIZATION_VARIANT_ID = 48190150672574;

  document.querySelectorAll('[data-remembrance-options]').forEach((wrapper) => {
    const productHandle = wrapper.dataset.productHandle;
    const productTitle =
      wrapper.dataset.productTitle ||
      (
        productHandle === 'dog-candle'
          ? 'Dog Candle'
          : productHandle === 'cat-candle'
            ? 'Cat Candle'
            : productHandle === 'three-candle-set'
              ? 'Three Candle Set'
              : 'Remembrance Candle'
      );

    const form = wrapper.closest('form[action*="/cart/add"]');

    if (!form) return;

    const errorBox = wrapper.querySelector('[data-remembrance-error]');
    let customSubmitInProgress = false;

    function showError(message) {
      if (!errorBox) {
        alert(message);
        return;
      }

      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;

      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function getQuantity() {
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = Number.parseInt(quantityInput?.value || '1', 10);

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function getMainVariantId() {
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = Number.parseInt(variantInput?.value || '', 10);

      return Number.isFinite(variantId) ? variantId : null;
    }

    function getSubmitButtons() {
      return Array.from(
        form.querySelectorAll(
          'button[type="submit"], input[type="submit"]'
        )
      );
    }

    function setLoading(isLoading) {
      getSubmitButtons().forEach((button) => {
        button.disabled = isLoading;
        button.setAttribute('aria-busy', String(isLoading));
      });
    }

    function getProductArea() {
      return (
        wrapper.closest('.product-information__grid') ||
        wrapper.closest('[data-product-grid-content]') ||
        document
      );
    }

    function getPackageSelect() {
      const productArea = getProductArea();

      const selects = Array.from(
        productArea.querySelectorAll(
          'variant-picker select, select[name^="options"], .product-form select'
        )
      );

      return selects.find((select) => {
        const values = Array.from(select.options).map((option) =>
          option.value.trim().toLowerCase()
        );

        return (
          values.includes('gift set') &&
          (
            values.includes('standard candle') ||
            values.includes('standard set')
          )
        );
      });
    }

    function findPackageValue(packageSelect, targetType) {
      if (!packageSelect) return null;

      const options = Array.from(packageSelect.options);

      if (targetType === 'gift') {
        return options.find(
          (option) =>
            option.value.trim().toLowerCase() === 'gift set'
        );
      }

      return options.find((option) => {
        const value = option.value.trim().toLowerCase();

        return (
          value === 'standard candle' ||
          value === 'standard set'
        );
      });
    }

    function setPackageOption(targetType) {
      const packageSelect = getPackageSelect();

      if (!packageSelect) {
        console.warn('Package selector was not found.');
        return;
      }

      const matchingOption = findPackageValue(
        packageSelect,
        targetType
      );

      if (!matchingOption) {
        console.warn(`Package option was not found: ${targetType}`);
        return;
      }

      packageSelect.value = matchingOption.value;

      packageSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }

    async function addItemsToCart(items) {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const responseData = await response.json().catch(() => null);

      if (!response.ok) {
        const message =
          responseData?.description ||
          responseData?.message ||
          'The selected items could not be added to cart.';

        throw new Error(message);
      }

      return responseData;
    }

    const giftSetCheckbox = wrapper.querySelector(
      '[data-gift-set-checkbox]'
    );

    giftSetCheckbox?.addEventListener('change', () => {
      clearError();

      setPackageOption(
        giftSetCheckbox.checked ? 'gift' : 'standard'
      );
    });

    /*
     * SINGLE CANDLE PRODUCTS
     * Remembrance Candle
     * Dog Candle
     * Cat Candle
     */
    const isSingleCandleProduct = [
      'remembrance-candle',
      'dog-candle',
      'cat-candle'
    ].includes(productHandle);

    if (isSingleCandleProduct) {
      const personalizationCheckbox = wrapper.querySelector(
        '[data-personalization-checkbox]'
      );

      const personalizationFields = wrapper.querySelector(
        '[data-personalization-fields]'
      );

      const petNameInput = wrapper.querySelector('[data-pet-name]');

      const wallConsentCheckbox = wrapper.querySelector(
        '[data-wall-consent]'
      );

      personalizationCheckbox?.addEventListener('change', () => {
        clearError();

        if (personalizationFields) {
          personalizationFields.hidden =
            !personalizationCheckbox.checked;
        }

        if (!personalizationCheckbox.checked) {
          if (petNameInput) {
            petNameInput.value = '';
          }

          if (wallConsentCheckbox) {
            wallConsentCheckbox.checked = false;
          }
        }
      });

      form.addEventListener(
        'submit',
        async (event) => {
          if (customSubmitInProgress) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          clearError();

          const personalizationSelected =
            Boolean(personalizationCheckbox?.checked);

          const petName = petNameInput?.value.trim() || '';

          if (personalizationSelected && !petName) {
            showError(
              'Please enter your pet’s name for personalization.'
            );

            petNameInput?.focus();
            return;
          }

          const mainVariantId = getMainVariantId();

          if (!mainVariantId) {
            showError(
              'The selected candle variant could not be found.'
            );
            return;
          }

          const quantity = getQuantity();

          const mainProductProperties = {
            Personalization: personalizationSelected
              ? 'Raised Gold Foil'
              : 'No'
          };

          if (personalizationSelected) {
            mainProductProperties["Pet's Name"] = petName;

            mainProductProperties[
              'Remembrance Wall Consent'
            ] = wallConsentCheckbox?.checked ? 'Yes' : 'No';
          }

          const items = [
            {
              id: mainVariantId,
              quantity,
              properties: mainProductProperties
            }
          ];

          if (personalizationSelected) {
            items.push({
              id: PERSONALIZATION_VARIANT_ID,
              quantity,
              properties: {
                "Pet's Name": petName,
                'For Product': productTitle,
                'Remembrance Wall Consent':
                  wallConsentCheckbox?.checked ? 'Yes' : 'No'
              }
            });
          }

          customSubmitInProgress = true;
          setLoading(true);

          try {
            await addItemsToCart(items);

            const root = window.Shopify?.routes?.root || '/';
            window.location.href = `${root}cart`;
          } catch (error) {
            console.error(error);

            showError(
              error.message ||
              'There was a problem adding these items to cart.'
            );

            customSubmitInProgress = false;
            setLoading(false);
          }
        },
        true
      );
    }

    /*
     * THREE CANDLE SET
     */
    if (productHandle === 'three-candle-set') {
      const candleCards = Array.from(
        wrapper.querySelectorAll('[data-candle]')
      );

      candleCards.forEach((card) => {
        const personalizationCheckbox = card.querySelector(
          '[data-candle-personalization]'
        );

        const personalizationFields = card.querySelector(
          '[data-candle-personalization-fields]'
        );

        const petNameInput = card.querySelector(
          '[data-candle-pet-name]'
        );

        const consentCheckbox = card.querySelector(
          '[data-candle-wall-consent]'
        );

        personalizationCheckbox?.addEventListener('change', () => {
          clearError();

          if (personalizationFields) {
            personalizationFields.hidden =
              !personalizationCheckbox.checked;
          }

          if (!personalizationCheckbox.checked) {
            if (petNameInput) {
              petNameInput.value = '';
            }

            if (consentCheckbox) {
              consentCheckbox.checked = false;
            }
          }
        });
      });

      form.addEventListener(
        'submit',
        async (event) => {
          if (customSubmitInProgress) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          clearError();

          const mainVariantId = getMainVariantId();

          if (!mainVariantId) {
            showError(
              'The selected Three Candle Set variant could not be found.'
            );
            return;
          }

          const quantity = getQuantity();
          const mainProductProperties = {};
          const personalizationItems = [];

          for (const card of candleCards) {
            const candleNumber = card.dataset.candle;

            const selectedDesign = card.querySelector(
              '[data-candle-design]:checked'
            );

            const personalizationCheckbox = card.querySelector(
              '[data-candle-personalization]'
            );

            const petNameInput = card.querySelector(
              '[data-candle-pet-name]'
            );

            const consentCheckbox = card.querySelector(
              '[data-candle-wall-consent]'
            );

            if (!selectedDesign) {
              showError(
                `Please select Cat or Dog for Candle ${candleNumber}.`
              );

              card.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

              return;
            }

            mainProductProperties[
              `Candle ${candleNumber} Design`
            ] = selectedDesign.value;

            if (personalizationCheckbox?.checked) {
              const petName = petNameInput?.value.trim() || '';

              if (!petName) {
                showError(
                  `Please enter the pet’s name for Candle ${candleNumber}.`
                );

                petNameInput?.focus();
                return;
              }

              const wallConsent = consentCheckbox?.checked
                ? 'Yes'
                : 'No';

              mainProductProperties[
                `Candle ${candleNumber} Personalization`
              ] = 'Raised Gold Foil';

              mainProductProperties[
                `Candle ${candleNumber} Pet Name`
              ] = petName;

              mainProductProperties[
                `Candle ${candleNumber} Wall Consent`
              ] = wallConsent;

              personalizationItems.push({
                id: PERSONALIZATION_VARIANT_ID,
                quantity,
                properties: {
                  'For Product': 'Three Candle Set',
                  'For Candle': `Candle ${candleNumber}`,
                  "Pet's Name": petName,
                  'Remembrance Wall Consent': wallConsent
                }
              });
            } else {
              mainProductProperties[
                `Candle ${candleNumber} Personalization`
              ] = 'No';
            }
          }

          mainProductProperties['Gift Set Upgrade'] =
            giftSetCheckbox?.checked ? 'Yes — All Three' : 'No';

          const items = [
            {
              id: mainVariantId,
              quantity,
              properties: mainProductProperties
            },
            ...personalizationItems
          ];

          customSubmitInProgress = true;
          setLoading(true);

          try {
            await addItemsToCart(items);

            const root = window.Shopify?.routes?.root || '/';
            window.location.href = `${root}cart`;
          } catch (error) {
            console.error(error);

            showError(
              error.message ||
              'There was a problem adding these items to cart.'
            );

            customSubmitInProgress = false;
            setLoading(false);
          }
        },
        true
      );
    }
  });
});